import { useState, useEffect } from "react";
import TreeItem from '@material-ui/lab/TreeItem';
import Sticky from 'react-sticky-el';
import { Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import TreeView from "@material-ui/lab/TreeView";


export default function GettingStarted() {
    const [currentSubItem, setCurrentSubItem] = useState(null);


    useEffect(() => {

        if (currentSubItem)
            scroller.scrollTo(currentSubItem)
        else
            scroll.scrollToTop()

    });


    return (
        <div>
            <div className="row">
                <div className="col-sm-9 pb-5 mb-5">
                    <h2 style={{ marginBottom: "20px" }}>{window.locale.translate("Getting Started")}</h2>
                    <Element name="Introduction">
                        <h5 style={{ marginBottom: "20px" }}>{window.locale.translate("Introduction")}</h5>
                        {window.locale.translate("Alcohol, as an excisable product, needs to be recorded in every step of its production. Therefore, the objective of this application is purely based on the record keeping of alcohol inside the warehouse as per the guidelines of the ATO. ")}
                        <br /><br />
                        {window.locale.translate("The application is built in coordination with distillers and spirit manufacturers just like you. The major concern that is being talked about is the calculations and conversions involved while producing or moving alcohol. eDistillery does all that automatically for you. So mixing and diluting in edistillery is just like happening physically however strengths and volumes can be physically verified with an Alcoholmeter or an Hydrometer.")}
                        <br /><br />
                        {window.locale.translate("Note: All these calculations are done automatically considering it has been done at standard 20Â°C.")}
                    </Element>
                    <Element name="Who" className="mt-5">
                        <h5 style={{ marginBottom: "20px" }}>{window.locale.translate("Who can use eDistillery ?")}</h5>
                        {window.locale.translate("eDistillery is developed for every spirit brand that needs to keep record of alcohol and may or may not be subject to report the stocks and disposals to the concerned authorities. ")}
                        <br /><br />
                        {window.locale.translate("eDistillery is best in the following cases:")}
                        <br />
                        -{window.locale.translate("You have a license permit from the ATO.")}
                        <br />
                        -{window.locale.translate("If you have a bonded warehouse and you ferment and distill the alcohol yourself.")}
                        <br />
                        -{window.locale.translate("If you purcahse raw alcohol and distill it yourself to produce your own brand.")}
                        <br />
                        -{window.locale.translate("If you purchase ready made spirits and either add flavor to it or just package them to sell your own brand.")}
                        <br />
                        -{window.locale.translate("You have a bonded warehouse.")}
                    </Element>
                    <Element name="Steps" className="mt-5">
                        <h5 style={{ marginBottom: "20px" }}>{window.locale.translate("Steps Involved")}</h5>
                        {window.locale.translate("Depending upon the type of your business, you may or may not need all the modules in eDistillery. eDistillery gives you the flexibility to pay and use only the modules required by your business. ")}
                        <br /><br />
                        {window.locale.translate("For a typical spirit producing warehouse, the following steps are involved in producing alcoholic beverages that edistillery covers:")}
                        <br />
                        -{window.locale.translate("Fermentation")}
                        <br />
                        -{window.locale.translate("Distillation")}
                        <br />
                        -{window.locale.translate("Bulk Production")}
                        <br />
                        -{window.locale.translate("Dilution")}
                        <br />
                        -{window.locale.translate("Aging")}
                        <br />
                        -{window.locale.translate("Mixing")}
                        <br />
                        -{window.locale.translate("Bottling")}
                        <br />
                        -{window.locale.translate("Bottling through vendors")}
                        <br />
                        -{window.locale.translate("Dispatches")}
                        <br />
                        -{window.locale.translate("Disposals of Feints")}
                        <br />
                        -{window.locale.translate("Sampling")}
                        <br />
                        <br />
                        {window.locale.translate("eDistillery allows its customers to get a bird eye view of all these steps and the warehouse by giving a virtual overview of the warehouse.It consists of storage containers that are used to store alcoholic beverages and work upon them.")}
                        <br />
                        <br />

                    </Element>


                </div>
                <div className="col-sm-3 pr-3">
                    <div className="">
                        <Sticky>
                            <TreeView>
                                <TreeItem nodeId="1" label="Introduction" onClick={() => setCurrentSubItem("Introduction")} />
                                <TreeItem nodeId="2" label="Who can use eDistillery ?" onClick={() => setCurrentSubItem("Who")} />
                                <TreeItem nodeId="3" label="Steps Involved" onClick={() => setCurrentSubItem("Steps")} />
                            </TreeView>
                        </Sticky>
                    </div>
                </div>
            </div>
        </div>
    )


}